// Mirrors HP.Framework InvitationStatus and HP.Web.Components AppointmentType so
// the cockpit can label interview appointments and drive the accept / deny /
// request-alternative actions through the existing appointment endpoint.
export const InvitationStatus = {
  Requested: 1,
  Accepted: 2,
  AlternativeRequested: 3,
  Denied: 4,
  Cancelled: 5
};

export const AppointmentType = {
  Accept: 0,
  Reject: 1,
  Deny: 2
};

// The invitation status a given appointment response results in, used to reflect
// the new state locally without reloading the whole list.
export const invitationStatusForResponse = (responseType) => {
  switch (responseType) {
    case AppointmentType.Accept:
      return InvitationStatus.Accepted;
    case AppointmentType.Reject:
      return InvitationStatus.AlternativeRequested;
    case AppointmentType.Deny:
      return InvitationStatus.Denied;
    default:
      return null;
  }
};

export default {
  InvitationStatus,
  AppointmentType,
  invitationStatusForResponse
};
